import LoadingIcons from './LoadingIcons'

export default LoadingIcons